function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5006",
  "data-name": "Group 5006",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4984",
  "data-name": "Group 4984"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_168",
  "data-name": "Rectangle 168",
  width: 34,
  height: 34,
  rx: 10,
  transform: "translate(0 0)",
  fill: "#ff3067"
})), /*#__PURE__*/React.createElement("g", {
  id: "image",
  transform: "translate(8.484 8.484)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4472",
  "data-name": "Group 4472"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4471",
  "data-name": "Group 4471"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4491",
  "data-name": "Group 4491"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3372",
  "data-name": "Path 3372",
  d: "M966.992,531.688H952.877a1.458,1.458,0,0,0-1.458,1.458h0v14.116a1.457,1.457,0,0,0,1.458,1.457h14.115a1.457,1.457,0,0,0,1.458-1.457V533.146A1.458,1.458,0,0,0,966.992,531.688Zm-.26,14.83a.486.486,0,0,1-.485.486H953.622a.487.487,0,0,1-.486-.486V533.891a.487.487,0,0,1,.486-.486h12.627a.486.486,0,0,1,.486.486Z",
  transform: "translate(-951.419 -531.688)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4490",
  "data-name": "Group 4490",
  transform: "translate(3.836 3.836)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_67",
  "data-name": "Rectangle 67",
  d: "M956.022,541.661h8.439a.768.768,0,0,1,.767.768h0a.768.768,0,0,1-.767.767h-8.439a.767.767,0,0,1-.767-.767h0A.767.767,0,0,1,956.022,541.661Z",
  transform: "translate(-955.255 -535.524)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_68",
  "data-name": "Rectangle 68",
  d: "M956.022,543.963h8.439a.767.767,0,0,1,.767.767h0a.767.767,0,0,1-.767.767h-8.439a.767.767,0,0,1-.767-.767h0A.767.767,0,0,1,956.022,543.963Z",
  transform: "translate(-955.255 -535.524)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  cx: 1.918,
  cy: 1.918,
  r: 1.918,
  transform: "translate(3.069)",
  fill: "#fff"
})))))));

function SvgPostGenerationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "post-generation-icon-svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostGenerationIcon);
export default __webpack_public_path__ + "static/media/postGenerationIcon.710c4013.svg";
export { ForwardRef as ReactComponent };